import { UserJson } from '../types/models';
import { BLOCKED_CLIENTS } from '../data/blocked-clients';

import { useAuth } from './use-auth';

export interface BlockedInvoice {
  number: string;
  date: string;
  amount: number;
}

export interface BlockedClient {
  id: string;
  name: string;
  invoices: BlockedInvoice[];
  totalDue: number;
}

const ALLOWED_EMAILS = ['fabien.buchheit@gmail.com', 'sogaris@camionnet.fr'];

/**
 * Liste des clients bloqués (impayés) désormais INTÉGRÉE à l'app (src/data/blocked-clients.ts),
 * à la place de l'ancien CSV publié depuis Google Sheets (qui se figeait). Pour la mettre à jour,
 * on édite ce fichier de données et on redéploie. Tout le reste (droits d'accès, matching flou
 * des noms, pop-up « client bloqué ») est inchangé.
 */

export function useBlockedClients(): {
  enabled: boolean;
  data: BlockedClient[];
  isLoading: boolean;
  error: Error | null;
  refresh: () => void;
} {
  const auth = useAuth();
  const user = (auth.user || undefined) as UserJson | undefined;
  const rawEmail = user && typeof user !== 'boolean' ? user.email : undefined;
  const email = rawEmail ? rawEmail.trim().toLowerCase() : undefined;
  const enabled = !!email && ALLOWED_EMAILS.includes(email);

  return {
    enabled,
    data: enabled ? BLOCKED_CLIENTS : [],
    isLoading: false,
    error: null,
    refresh: () => undefined,
  };
}

/**
 * Renvoie la liste des clients bloqués. Conserve la signature asynchrone pour les appelants
 * (handlers onSave/onClick) même si la donnée est maintenant locale et immédiate.
 */
export async function ensureBlockedData(): Promise<BlockedClient[]> {
  return BLOCKED_CLIENTS;
}

/* ------------------------------------------------------------------ */
/* Rapprochement nom app <-> nom comptable : voir src/utils/blocked-match */
/* ------------------------------------------------------------------ */

export { isBlockedMatch, findBlockedMatch } from '../utils/blocked-match';
